import styles from "./index.module.scss"

export const Features = () => {
  return (
    <div className={styles.Container}>
      <div className={styles.Title}>
        Co-build whatever your want with users and peers
      </div>
      <div className={styles.Subtitle}>
        DeGit is a Web3 DApp for remote code collaboration,
        where developers host Git repositories, collaborate and
        earn rewards while contributing to open source.
      </div>
    </div>
  )
}
